import { FlowConditionValuationReportDetails } from './types.flow';

import {
  FLOW_CONDITION_VALUATIONREPORT_DETAILS_FIELD,
  DEFAULT_FLOW_CONDITION_VALUATIONREPORT_DETAILS_FIELD,
} from './constants';
import {
  asConditionFieldProp,
  emptyConditionField,
} from '~/scenes/Automation/Flows/Actions/Base';
import { asValuationReportEventParameterValue } from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/Event';
import equalsEventPointer from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/Event/equalsEventPointer';
import cleanedFilename from '~/util/cleanedFilename';
import { ValuationReportPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';
import { ConditionField } from '~/scenes/Automation/Flows/Actions/Base/FlowCondition/Primitive/types.flow';
import { FlowConditionFieldsFragment } from '~/graphql/types';

type ConditionType = Extract<
  FlowConditionFieldsFragment,
  { __typename: 'Flow_Condition_Event_Contact_App_ValuationReport_Details' }
>;

type ExpectedConditionEventType = Extract<
  ConditionType['event'],
  { __typename: 'Flow_Parameter_Event_Contact_AppValuationReport_Pointer' }
>;

type ExpectedConditionType = ConditionType & {
  event: ExpectedConditionEventType;
};

const isConditionEventAppValuationReportPointer = (
  event: ConditionType['event'],
): event is ExpectedConditionEventType =>
  event.__typename ===
  'Flow_Parameter_Event_Contact_AppValuationReport_Pointer';

const isExpectedEventCondition = (
  condition: ConditionType,
): condition is ExpectedConditionType =>
  isConditionEventAppValuationReportPointer(condition.event);

const asFlowConditionValuationReportDetailsProp = (
  conditions: Array<ConditionType>,
  allShouldBeTrue: boolean,
): Omit<FlowConditionValuationReportDetails, 'id'> => {
  const fields: Array<ConditionField> = [];
  let eventParameter: ValuationReportPointerParameterValue | null = null;

  conditions.forEach(condition => {
    if (!isExpectedEventCondition(condition)) return;
    const { event } = condition;
    const newEvent = asValuationReportEventParameterValue(event);
    if (
      eventParameter != null &&
      !equalsEventPointer(eventParameter, newEvent)
    ) {
      throw Error(
        `${cleanedFilename(
          __filename,
        )} | Should not occur | different events in the conditions (${JSON.stringify(
          conditions,
          null,
          2,
        )})`,
      );
    }
    eventParameter = newEvent;

    let setField: ConditionField = emptyConditionField(
      DEFAULT_FLOW_CONDITION_VALUATIONREPORT_DETAILS_FIELD,
    );

    Object.keys(FLOW_CONDITION_VALUATIONREPORT_DETAILS_FIELD).forEach(
      fieldName => {
        if (condition[fieldName] != null) {
          setField = asConditionFieldProp(
            FLOW_CONDITION_VALUATIONREPORT_DETAILS_FIELD[fieldName],
            condition[fieldName],
          );
          /** @QUESTION Was this a bug then? Or do we only allow one field?*/
          fields.push(setField);
        }
      },
    );
  });

  if (eventParameter == null) {
    throw Error(
      `${cleanedFilename(
        __filename,
      )} | Should not occur | no event found in conditions (${JSON.stringify(
        conditions,
        null,
        2,
      )})`,
    );
  }

  return {
    type: 'Flow_Condition_Event_Contact_App_ValuationReport_Details',
    event: eventParameter,
    fields,
    allShouldBeTrue,
  };
};

export default asFlowConditionValuationReportDetailsProp;
